module.exports = __webpack_public_path__ + "img/scene5.a6bf2e7b.png";